import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  EVENT_TYPE_LABELS, EVENT_TYPE_VALUES, EVENT_STATUS_LABELS,
  type CalendarFilters, type CalendarEventType, type CalendarEventStatus,
} from "@cold-crew/shared";

interface EventoFiltersBarProps {
  filters:  Partial<CalendarFilters>;
  onChange: (next: Partial<CalendarFilters>) => void;
}

const inputCls = cn(
  "h-9 rounded-md border border-input bg-background px-3 text-sm",
  "placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring",
  "transition-colors"
);
const selectCls = cn(inputCls, "pr-8 cursor-pointer");

export function EventoFiltersBar({ filters, onChange }: EventoFiltersBarProps) {
  const hasActive = filters.tipo || filters.status || filters.date_from || filters.date_to;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* Tipo */}
      <select
        value={filters.tipo ?? ""}
        onChange={(e) => onChange({ ...filters, tipo: (e.target.value as CalendarEventType) || undefined, page: 1 })}
        className={selectCls}
      >
        <option value="">Todos los tipos</option>
        {EVENT_TYPE_VALUES.map((t) => (
          <option key={t} value={t}>{EVENT_TYPE_LABELS[t]}</option>
        ))}
      </select>

      {/* Status */}
      <select
        value={filters.status ?? ""}
        onChange={(e) => onChange({ ...filters, status: (e.target.value as CalendarEventStatus) || undefined, page: 1 })}
        className={selectCls}
      >
        <option value="">Todos los estados</option>
        {(["pendiente", "completado", "cancelado"] as CalendarEventStatus[]).map((s) => (
          <option key={s} value={s}>{EVENT_STATUS_LABELS[s]}</option>
        ))}
      </select>

      {/* Date range */}
      <input type="date" value={filters.date_from ?? ""}
        onChange={(e) => onChange({ ...filters, date_from: e.target.value || undefined, page: 1 })}
        className={cn(inputCls, "w-38")} title="Desde" />
      <span className="text-muted-foreground text-sm">—</span>
      <input type="date" value={filters.date_to ?? ""}
        onChange={(e) => onChange({ ...filters, date_to: e.target.value || undefined, page: 1 })}
        className={cn(inputCls, "w-38")} title="Hasta" />

      {hasActive && (
        <button
          onClick={() => onChange({ page: 1, limit: filters.limit ?? 30 })}
          className="flex items-center gap-1 px-2.5 py-1.5 text-xs text-muted-foreground hover:text-foreground rounded-md hover:bg-muted transition-colors"
        >
          <X className="size-3" /> Limpiar
        </button>
      )}
    </div>
  );
}
